import React from 'react';
import { Typography, Box, Stack, Paper } from '@mui/material';
import profile from '../profileData';

const Seminars = () => (
  <Box id="seminars" sx={{ py: { xs: 3, md: 5 }, px: { xs: 2, md: 0 }, maxWidth: { xs: '100%', md: 1200 }, mx: 'auto' }}>
    <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
      <Box sx={{ width: 4, height: 32, bgcolor: 'primary.main', mr: 2, borderRadius: 2 }} />
      <Typography variant="h4" fontWeight={700} sx={{ fontFamily: 'Montserrat, sans-serif', letterSpacing: 1, fontSize: { xs: 24, md: 32 } }}>
        Seminars & Conferences
      </Typography>
    </Box>
    <Stack spacing={3} mt={2}>
      {profile.seminars.map((seminar, idx) => (
        <Paper 
          key={idx} 
          elevation={1}
            sx={{ 
            p: { xs: 2, sm: 2.5, md: 2.5 }, 
            borderRadius: 3,
            border: '1px solid',
            borderColor: 'divider',
            transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
            '&:hover': {
              boxShadow: '0 8px 24px rgba(0, 0, 0, 0.12)',
              transform: 'translateY(-4px)',
              borderColor: 'primary.main',
            }
          }}
        >
          <Box sx={{ 
            display: 'flex', 
            flexDirection: { xs: 'column', sm: 'row' },
            alignItems: { xs: 'flex-start', sm: 'flex-start' },
            gap: { xs: 1, sm: 1.5 }
          }}>
            {seminar.year && (
              <Box sx={{ 
                display: 'flex', 
                alignItems: 'center', 
                gap: 1,
                mb: { xs: 0.5, sm: 0 },
                flexShrink: 0
              }}>
                <Typography 
                  variant="h6" 
                  sx={{ 
                    fontFamily: 'Montserrat, sans-serif', 
                    fontSize: { xs: 18, sm: 20, md: 22 },
                    fontWeight: 600,
                    minWidth: { xs: 'auto', sm: 80 },
                    color: 'text.primary'
                  }}
                >
                  {seminar.month ? `${seminar.month} ${seminar.year}` : seminar.year}
                </Typography>
                <Box 
                  sx={{ 
                    width: 8, 
                    height: 8, 
                    bgcolor: '#c41e3a', 
                    borderRadius: '50%',
                    flexShrink: 0,
                    display: { xs: 'none', sm: 'block' }
                  }} 
                />
              </Box>
            )}
            <Box sx={{ flex: 1, width: { xs: '100%', sm: 'auto' } }}>
              <Typography 
                variant="h6" 
                fontWeight={600} 
                sx={{ 
                  fontFamily: 'Montserrat, sans-serif', 
                  fontSize: { xs: 18, sm: 20, md: 24 }, 
                  mb: seminar.conferences && seminar.conferences.length > 0 ? 1.5 : 0,
                  lineHeight: 1.3
                }}
              >
                {seminar.title}
              </Typography>
              {seminar.conferences && seminar.conferences.length > 0 && (
                <Box component="ul" sx={{ pl: { xs: 2.5, sm: 3 }, mt: 1, mb: 0 }}>
                  {seminar.conferences.map((conf, confIdx) => (
                    <Typography 
                      key={confIdx}
                      component="li" 
                      variant="body1" 
                      sx={{ 
                        color: 'text.secondary', 
                        fontSize: { xs: 14, sm: 15, md: 18 },
                        mb: 0.5,
                        lineHeight: 1.6
                      }}
                    >
                      {conf}
                    </Typography>
                  ))}
                </Box>
              )}
            </Box>
          </Box>
        </Paper>
      ))}
    </Stack>
  </Box>
);

export default Seminars; 